module.exports = __webpack_public_path__ + "static/media/WPD_logo.c9fb89ec.png";